export default {
  images: [],
  current_gallery: null
}
